import { BaseModel } from "./base-model";
import { Rs1345UpdateInfo } from "../services/rs1345-service";
import { CrossedGeometry } from "../utils/geometries-intersection";
import { RouteGeometry } from "./voyage-routing-model";

export type BroadcastType = "weather bulletins" | "navigational warnings" | "ice warnings and reports";

export interface Position {
    type: string;
    coordinates: number[];
}

export interface Service {
    designator: string;
    frequencyHz: number;
    rangeNM?: number;
    broadcasts: BroadcastType[];
}

export interface Navtex {
    name: string;
    address: string;
    position: Position;
    services: Service[];
}

export interface NavtexStation extends CrossedGeometry {
    name: string;
    address: string;
    position: Position;
    designator: string;
    frequencyHz: number;
    rangeNM?: number;
    broadcasts: BroadcastType[];
}

export abstract class VesselRs1345ModelBase extends BaseModel {
    abstract getUpdateInfo(): Promise<Map<string, Rs1345UpdateInfo>>;
    abstract get latestUpdateDate(): string | null;
    abstract getStations(): Promise<NavtexStation[]>;
    abstract getHtml(address: string, existingHtml?: string): void;
    abstract getNavWarningStationsCrossingRoute(route: RouteGeometry): string;
    abstract getWeatherStationsCrossingRoute(route: RouteGeometry): string;
}

let VesselRs1345Model: VesselRs1345ModelBase|null = null;

function setVesselRs1345Model(model: VesselRs1345ModelBase) {
    VesselRs1345Model = model;
}

export { VesselRs1345Model, setVesselRs1345Model };
